export function isOpenAppeal(appeal) {
  if (!appeal) return false;
  if (appeal.finalStatus === "approved" || appeal.finalStatus === "rejected") {
    return false;
  }
  if (appeal.status === "approved" || appeal.status === "rejected") {
    return false;
  }
  return true;
}

/** GM must accept or reject once HR's 5 working days have passed. */
export function isGmAppealActionRequired(appeal) {
  return isOpenAppeal(appeal) && appeal.gmActionRequired === true;
}

/** Still inside HR's window: the GM can read it and cannot decide it. */
export function isGmAppealViewOnly(appeal) {
  return isOpenAppeal(appeal) && !isGmAppealActionRequired(appeal);
}

export function getAppealDeadlineRemaining(dueAt, now = new Date()) {
  const due = new Date(dueAt);
  if (!dueAt || Number.isNaN(due.getTime())) return null;
  const totalMs = due.getTime() - now.getTime();
  if (totalMs <= 0) {
    return { expired: true, days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
  const totalSeconds = Math.floor(totalMs / 1000);
  return {
    expired: false,
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}

export function formatAppealDeadline(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("ar-EG", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
